import React, { useEffect, useState } from "react";
import {
  DownOutlined,
  UpOutlined,
  CarryOutOutlined,
  UserOutlined,
  ProfileOutlined,
  FileTextOutlined,
  BellOutlined,
  DashboardOutlined,
  SettingOutlined,
  NotificationOutlined,
  QrcodeOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { MenuItemProps, SidebarList, SubmenuItem } from "../../models/Sidebar";
import { useApplicationContext } from "../../application/ApplicationContext";
import "./Sidebar.scss";
import { setCurrentPage } from "../../store-redux/slices/ChangePageSlice";
import { useDispatch, useSelector } from "react-redux";
import { setPageItems } from "../../store-redux/slices/ChangeItemsPerPage";

const Sidebar = (sidebarList: SidebarList) => {
  const { state, setActiveMenuRow } = useApplicationContext();
  const dispatch = useDispatch();

  const [dataList, setDataList] = useState<MenuItemProps[]>(
    sidebarList.sidebarList
  );
  const [activeRowId, setActiveRowId] = useState<number>(0);
  const [activeSubRowId, setActiveSubRowId] = useState<number>(0);

  const handleOpen = (id: number) => {
    const copyArr = [...dataList];
    const filterA: any = copyArr?.find((row: MenuItemProps) => row.id === +id);

    filterA.open = !filterA.open;
    setDataList(copyArr);
  };

  useEffect(() => {
    setActiveRowId(state.activeMenuRow?.activeMenuItem ?? 0);
  }, [state.activeMenuRow]);

  return (
    <div>
      <div className="sidebar">
        {dataList.map((el: MenuItemProps, i: number) => {
          return (
            <div key={i + 1} className="item">
              <div
                onClick={() => {
                  handleOpen(el.id);
                  setActiveRowId(el.id);
                  if (el.id > 5) {
                    setActiveMenuRow(el.id, 0);
                  }
                  if (el && el?.command) el.command();
                }}
                className={`main-part ${activeRowId === el.id && "active"} ${
                  activeRowId === el.id &&
                  activeSubRowId !== 0 &&
                  "active-submenu"
                }`}
              >
                {
                  //used different library for side menu icons
                  el.id === 1 ? (
                    <CarryOutOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 2 ? (
                    <UserOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 3 ? (
                    <ProfileOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 4 ? (
                    activeRowId === el.id ? (
                      <i
                        className="bi bi-houses"
                        style={{ fontSize: "1.4rem", color: "#ffffff" }}
                      ></i>
                    ) : (
                      <i
                        className="bi bi-houses"
                        style={{ fontSize: "1.4rem", color: "#C7363D" }}
                      ></i>
                    )
                  ) : el.id === 5 ? (
                    <FileTextOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 6 ? (
                    <BellOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 7 ? (
                    <DashboardOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 8 ? (
                    <NotificationOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 9 ? (
                    <QrcodeOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : el.id === 10 ? (
                    <PictureOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  ) : (
                    <SettingOutlined
                      className={`${
                        activeRowId === el.id ? "menu-icon-active" : "menu-icon"
                      }`}
                    />
                  )
                }
                <p className="header">{el.label}</p>
                <p className={"menu-arrow"}>
                  {el.items !== undefined ? (
                    el.open ? (
                      <UpOutlined />
                    ) : (
                      <DownOutlined />
                    )
                  ) : (
                    <span
                      className={`${
                        activeRowId === el.id
                          ? "menu-arrow-no-submenu-active"
                          : "menu-arrow-no-submenu"
                      }`}
                    >
                      __
                    </span>
                  )}
                </p>
              </div>
              {el.open && el.items !== undefined ? (
                <div onClick={() => ""} className="sub-menu">
                  {el.items.map((subMenuEl: SubmenuItem, i: number) => {
                    return (
                      <div
                        onClick={() => {
                          if (subMenuEl.command !== undefined) {
                            setActiveRowId(subMenuEl.mainId);
                            setActiveSubRowId(subMenuEl.id);
                            setActiveMenuRow(subMenuEl.mainId, subMenuEl.id);
                            subMenuEl.command();

                            dispatch(setCurrentPage(1)); /// DISPATCH ACTION FROM REDUX
                            dispatch(setPageItems(30));
                          }
                        }}
                        key={i + 1}
                        className={`row ${
                          el.id === state.activeMenuRow?.activeMenuItem &&
                          subMenuEl.id === state.activeMenuRow.activeSubMenuItem
                            ? "active-sub-menu-class"
                            : "unactive-sub-menu-class"
                        }`}
                      >
                        <div className="inner-container">
                          <img className="img-sub-menu" src={subMenuEl.icon} />
                          <p className="sub-menu-header">{subMenuEl.label}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
